import { action } from 'typesafe-actions';
import { SET_PROMPT } from './types';

export const setPrompt = (value: string) => action(SET_PROMPT, value);
